// This file should contain any shared constant values used throughout the application
// Import the file to access the constants in components

import { DateTimeOptions } from 'luxon';

export const DATE_TIME_OPTIONS: DateTimeOptions = {
  locale: 'en-AU',
  zone: 'Australia/Sydney',
};

export const SEARCH_DEBOUNCE_TIME = 500;
export const SHORT_DATE = 'dd/MM/yyyy';
export const MEDIUM_DATE = 'd MMM yyyy';
export const MEDIUM_DATE_TIME = 'd MMM yyyy tt';
export const MEDIUM_DATE_SHORT_TIME = 'd MMM yyyy t';
export const LONG_DATE = 'd MMMM yyyy';
export const LONG_DATE_TIME = 'd MMMM yyyy tt';
export const TIME_ONLY = 'tt';
export const DEFAULT_PAGE_SIZES = [25, 50, 100, 150];
